import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'

import { Pencil } from 'lucide-react'
import { Button, ButtonGroup, DefaultTooltip, InputGroup } from 'twyne-new.ui'

import Select from '@Components/formsy/Select'
import Form from 'modules/settings/views/validator/containers/Form'

import { getValidatorOptions } from './options'

function RuleItemValidator({ value, onChange, handleOpenValidatorModal, origin, disabled }) {
  const [isOpen, setIsOpen] = useState(false)
  const [modalOrigin, setModalOrigin] = useState(false)
  const [validatorId, setValidatorId] = useState(null)
  const [options, setOptions] = useState([])

  useEffect(() => {
    getValidatorOptions().then(options => setOptions(options))

    if (['path-page', 'form-visibility', 'form-populate'].includes(origin)) {
      setModalOrigin(true)
    }
  }, [])

  const handleValidatorSelect = opt => {
    const value = opt ? opt.value : null
    onChange(value)
  }

  const handleValidatorEdit = id => {
    if (modalOrigin) {
      handleOpenValidatorModal(id)
    } else {
      setValidatorId(id ? id : null)
      setIsOpen(true)
    }
  }

  const handleEditCancel = () => {
    setIsOpen(false)
  }

  const handleEditSave = id => {
    handleEditCancel()
    getValidatorOptions().then(options => {
      setOptions(options)
      handleValidatorSelect({ value: id })
    })
  }

  const ValidatorModal = () => {
    if (!isOpen || origin === 'path-page') {
      return null
    }

    return <ValidatorComp
      validatorId={validatorId}
      onSubmit={id => handleEditSave(id)}
      onCancel={() => handleEditCancel()}
    />
  }

  return <>
    <InputGroup>
      <Select
        name="validator-rule"
        validationErrors={{ isRequired: '' }}
        className="form-control p-0"
        value={value}
        options={options}
        onChange={handleValidatorSelect}
        clearable={false}
        disabled={disabled}
        required
      />
      <ButtonGroup>
        <Button size="sm" color="accent" onClick={() => handleValidatorEdit()} disabled={disabled}>Add</Button>
        <DefaultTooltip content='Edit' triggerProps={{ asChild: true }}>
          <Button size="sm" color="accent" variant='outline' onClick={() => handleValidatorEdit(value)} disabled={!value || disabled ? true : false}>
            <Pencil size={16} />
          </Button>
        </DefaultTooltip>
      </ButtonGroup>
    </InputGroup>
    <ValidatorModal />
  </>
}

export const ValidatorComp = ({ validatorId, onSubmit, onCancel }) => <Form
  validatorId={validatorId}
  onSubmit={onSubmit}
  onCancel={onCancel}
/>

RuleItemValidator.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  handleOpenValidatorModal: PropTypes.func,
  origin: PropTypes.oneOf(['integration', 'page', 'path-page', 'profile', 'form-visibility', 'form-populate']),
  disabled: PropTypes.bool,
}

export default RuleItemValidator
